import * as angular from "angular";
import { PermissionCheck } from "../../shared/permission";

let BulkActionsComponent = {
    selector: "vcBulkActions",
    templateUrl: "/angular/components/people/bulk-actions.component.html",
    bindings: {
        data: "=?",
        exportFunction: "&?",
        groupFunction: "&?",
        mergeFunction: "&?",
        deleteFunction: "&?",
        anonymizeFunction: "&?",
        bulkEditFunction: "&?",
        removeFromGroupFunction: "&?",
        activateFunction: "&?",
        deactivateFunction: "&?",
        teamFunction: "&?",
        resendFunction: "&?",
        approveFunction: "&?",
        rejectFunction: "&?",
        pendingSelected: "<?",
        checkManager: "=?",
        group: "=?",
        refreshFunction: "&?",
        statusFunction: "&?",
        bulkAssignFunction: "&?",
        geojsonFunction: "&?",
        kmlFunction: "&?",
        shapefileFunction: "&?",
        groups: "=?",
        disableRefreshButton: "=?",
        deletePermission: "=?",
    },
    controller: class BulkActionsController {
        // * bindings for typescript compiler *
        public data?: any;
        public exportFunction?: any;
        public groupFunction?: any;
        public mergeFunction?: any;
        public deleteFunction?: any;
        public anonymizeFunction?: any;
        public bulkEditFunction?: any;
        public removeFromGroupFunction?: any;
        public activateFunction?: any;
        public deactivateFunction?: any;
        public teamFunction?: any;
        public resendFunction?: any;
        public approveFunction?: any;
        public rejectFunction?: any;
        public pendingSelected?: boolean;
        public checkManager?: any;
        public group?: any;
        public statusFunction?: any;
        public bulkAssignFunction?: any;
        public geojsonFunction?: any;
        public kmlFunction?: any;
        public shapefileFunction?: any;
        public refreshFunction?: any;
        public groups?: any;
        public disableRefreshButton?: any;
        public deletePermission?: string;
        // ************************************

        private isLeaderView: boolean;
        private __app_type: string;
        public permissionProvider: PermissionCheck;

        constructor(PermissionCheck: PermissionCheck, __app_type: string) {
            this.__app_type = __app_type;
            this.permissionProvider = PermissionCheck;
            this.isLeaderView = this.__app_type == "LEADER";
        }

        callMergeFunction($event: any): void {
            let houseoccupants = [];
            angular.forEach(this.checkManager.items, (item) => {
                if (this.checkManager.checked_items.includes(item.hoid)) {
                    houseoccupants.push(item);
                }
            });

            this.mergeFunction({
                duplicate: {
                    houseoccupants: {
                        primary: houseoccupants[0],
                        secondary: houseoccupants[1],
                    },
                },
                $event: $event,
            });
        }

        checkForRefresh(gids: any): boolean {
            if (gids.length > 0) {
                if (this.groups) {
                    let displayButton = this.groups.findIndex(
                        (group) => gids.includes(group.gid) && group.fid != null
                    );
                    return displayButton > -1 ? true : false;
                }

                return false;
            }
        }

        showRemoveButton(): boolean {
            return (
                (this.permissionProvider.hasPermission("BULK_ACTION") ||
                    this.permissionProvider.hasPermission("EDIT_GROUP")) &&
                this.removeFromGroupFunction &&
                !this.isLeaderView &&
                this.group &&
                !this.group.fid
            );
        }
    },
};

angular
    .module("people", [], ($compileProvider) => {
        $compileProvider.aHrefSanitizationWhitelist(
            /^\s*(https?|mailto|sms|tel):/
        );
    })
    .component(BulkActionsComponent.selector, BulkActionsComponent);
